<div class="statsPopup">
  <h5>
    <ng-container *ngIf="!stats.player">
      {{ 'Team data in this grid' | translate }}
    </ng-container>
    <ng-container *ngIf="stats.player">
      {{ 'Player data in this grid' | translate }}
    </ng-container>
  </h5>
  <h6>
    {{ stats.player ? (stats.player.number + '. ') : '' }}
    {{ stats.player ? stats.player.name : stats.team }}
    <small *ngIf="stats.player">{{ stats.team }}</small>
  </h6>
  <div class="stats" *ngIf="!stats.empty">
    <p class="main">{{ stats.points }} <span class="unit">{{ 'points' | translate }}</span></p>
    <p>{{ stats.shots - stats.failures }}<span> / {{ stats.shots }}</span> <span class="unit">{{ 'shots' | translate }}</span></p>
    <p><span class="square" [style.background-color]="stats.color"></span>{{ stats.accuracy }} <span>%</span> <span class="unit">{{ 'accuracy' | translate }}</span></p>
  </div>
  <p class="noshots" *ngIf="stats.empty">{{'No shots' | translate}}</p>
</div>